import type { SVGProps } from 'react';

const SvgLicensePlate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 2h5v2H4v3H2zM22 2h-5v2h3v3h2zM2 22v-5h2v3h3v2zM22 22v-5h-2v3h-3v2zM17.664 8.11H6.414v7.788h11.25zM16.5 10.3H7.578v3.407H16.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLicensePlate;
